import React, { useCallback, useState } from "react";
import styles from "./instruction-popup.module.scss";
import { PopupWindow } from "../popup-window/popup-window";
import Button from "../button/button";
import { IUseWhatsappFormParams, useWhatsappForm } from "../../hooks/use-whatsapp-form.hook";

interface InstructionPopupProps {
  active: boolean;
  whatsappParams: IUseWhatsappFormParams;
  onClose?: () => void;
  onButtonClick?: () => void;
}

export function InstructionPopup({ whatsappParams, active, onClose, onButtonClick }: InstructionPopupProps) {
  const goToWhatsapp = useWhatsappForm(whatsappParams);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const submitHandler = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);

    await goToWhatsapp();
    setButtonDisabled(false);
    onButtonClick && onButtonClick();
  }, [goToWhatsapp]);

  const closeHandler = () => {
    onClose && onClose();
  }
  
  return (
    <PopupWindow active={active} onClose={closeHandler} showCloseButton={true}>
      <form onSubmit={submitHandler} className={styles.container}>
        <h2 className={styles.header}>
          Перейдите в whatsapp и отправьте сообщение
        </h2>
        <img className={styles.image} src={'https://cdn.reserve-donkin-leads.ru/img/wa_instruction.jpg'} alt="" />
        <Button 
          type="submit"
          value={"Перейти в whatsapp"} 
          mode="whatsApp" 
          disabled={buttonDisabled}
          />
        <span className={styles.underButtonText}>
          Если whatsApp не открывается, то закройте это попап окно и оставьте заявку в форме
        </span>
      </form>
    </PopupWindow>
  )
}